module.exports = __webpack_public_path__ + "29f021160f4cf4b55272728f3e5a7e7d.jpg";